import Contact, { ContactDto } from "../contact/models/contact"
import { Entity } from "../helpers/Entity"

type OrderAttemptAttributesDto = {
    status: string
    source: string
    amount: string
    currency: string
    errorMsg: string
    attemptDate: Date
    contactName: string
    contact: ContactDto
    priceListId: string
}

export type OrderAttemptDto = {
    id: string
    type: string
    attributes: OrderAttemptAttributesDto
}

export default class OrderAttempt implements Entity {
    dto: OrderAttemptDto
    contact: Contact
    constructor(dto: OrderAttemptDto) {
        this.dto = dto
        this.contact = new Contact(dto.attributes.contact)
    }

    isLoaded() {
        return this.dto.id != ""
    }

    getId() {
        return this.dto.id
    }

    getStatus() {
        return this.dto.attributes.status
    }

    getAttemptDate() {
        return this.dto.attributes.attemptDate
    }

    getContactName() {
        return this.contact.getName()
    }

    getAmount() {
        return this.dto.attributes.amount
    }

    getCurrency() {
        return this.dto.attributes.currency
    }

    getPriceListId() {
        return this.dto.attributes.priceListId
    }
}

export function orderAttemptFromSearch(): OrderAttempt {
    return new OrderAttempt({} as OrderAttemptDto)
}



// WEBPACK FOOTER //
// ./src/state/price-list/OrderAttempt.ts